const UnauthorizedBanner = () => {
  return (
    <div className="msds-text-header-2-bold mb-4">
      Sorry, but you don't have the necessary permissions to access this page.
    </div>
  );
};

export default UnauthorizedBanner;
